import { Grid } from '@material-ui/core';
import { observer } from 'mobx-react';
import { useLoanTypeStore } from '../../../hooks/useLoanTypeStore';
import { BorrowerInformationAccordionSummary } from './borrowerInformationAccordion';
import { EntityInformationSummaryCard } from './entityInformationSummaryCard';
import { OneToolCardBorder } from './oneToolCard';
import { SearchExistingEntityCard } from './searchExistingEntityCard';

export const SearchExistingEntity = observer(() => {
  const { loanTypeStore } = useLoanTypeStore();
  const {
    borrowerEntityInformationStore,
    borrowerInformationStore,
  } = loanTypeStore;

  const borrowerEntityId =
    borrowerEntityInformationStore.borrowerEntityFormStore.form.fields
      .borrowerEntityId.value;

  const borrowerFormStores = [
    borrowerInformationStore.mainBorrowerFormStore,
    ...borrowerInformationStore.coBorrowersFormStores,
  ].filter(
    borrowerFormStore => !!borrowerFormStore.form.fields.firstName.value
  );

  return (
    <Grid container spacing={2}>
      <Grid item xs={12}>
        <SearchExistingEntityCard />
      </Grid>
      {!!borrowerEntityId && (
        <>
          <Grid item xs={12}>
            <EntityInformationSummaryCard />
          </Grid>
          {borrowerFormStores.map(borrowerFormStore => (
            <Grid item xs={12}>
              <OneToolCardBorder>
                <BorrowerInformationAccordionSummary
                  borrowerFormStore={borrowerFormStore}
                />
              </OneToolCardBorder>
            </Grid>
          ))}
        </>
      )}
    </Grid>
  );
});
